// extracted by mini-css-extract-plugin
export default {"container":"resume_container__6ZxB4","page":"resume_page__ZSgbP"};